export const NAME = 'STRIPE';

export const creditCardDetails = (store) => store[NAME].creditCard.fetch.data;
